<article
  class="review p-2 border rounded bg-white h-100 d-flex flex-column justify-content-between"
>
  <!-- content top -->
  <div>
    <div class="d-flex justify-content-between align-items-center pb-2">
      <wl-review-stars
        [score]="review().rating"
        [a11yText]="
          'reviewsFeature.a11y.reviewScore'
            | translate: { rating: review().rating }
        "
      />
      <div
        class="review__score h4 d-flex justify-content-center align-items-center"
        aria-hidden="true"
      >
        {{ review().rating }}
      </div>
    </div>
    <h3 class="h4 review__title" [title]="review().title">
      {{ review().title | sentenceCase }}
    </h3>
    <div
      #reviewText
      class="review__text"
      [class.review__text--expanded]="reviewTextExpanded()"
    >
      {{ review().content }}
    </div>
    @if (reviewTextTruncated || reviewTextExpanded()) {
      <a
        class="review__read-more-link d-inline-block mt-1"
        (click)="onExpand($event)"
        href="#"
      >
        @let text =
          reviewTextExpanded()
            ? ('reviewsFeature.readLess' | translate)
            : ('reviewsFeature.readMore' | translate);

        {{ text }}
        <crnt-icon
          [icon]="reviewTextExpanded() ? 'chevron-up' : 'chevron-down'"
          size="small"
        />
      </a>
    }
  </div>

  <!-- content bottom -->
  <div>
    <div class="pt-2 fw-bold">
      <crnt-visually-hidden>{{
        'reviewsFeature.a11y.reviewerSection' | translate
      }}</crnt-visually-hidden>
      <span>{{ review().author }}, {{ review().city | titlecase }}</span>
    </div>
    <div class="review__date">
      <crnt-visually-hidden>{{
        'reviewsFeature.a11y.dateSection' | translate
      }}</crnt-visually-hidden>
      {{ review().date | date: 'dd-MM-yyyy' }}
    </div>
    @if (review().wouldRecommend) {
      <div class="mt-2 d-flex">
        <crnt-icon icon="check" class="text-success me-1" />
        <span>
          {{
            'reviewsFeature.recommendationText' | translate: { brand: brand }
          }}</span
        >
      </div>
    }
  </div>
</article>
